"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlFor = exports.setConfig = exports.putJson = exports.put = exports.postJson = exports.post = exports.patchJson = exports.patch = exports.isEmpty = exports.getJson = exports.get = exports.destroyJson = exports.destroy = exports.delayedResult = exports.apiUrl = void 0;
const query_string_1 = __importDefault(require("query-string"));
let CONFIG_FUNC = undefined;
const setConfig = (f) => {
    CONFIG_FUNC = f;
};
exports.setConfig = setConfig;
//////////////////////////////////////////////////////////////////////////////
// Standard Network Calls                                                   //
//////////////////////////////////////////////////////////////////////////////
/**
 * Performs a PATCH request and returns a promise for the results.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const destroy = (path, opts = {}) => rawRequest('DELETE', path, opts);
exports.destroy = destroy;
/**
 * Calls `destroy` and then parses the JSON for you.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const destroyJson = (path, opts = {}) => destroy(path, opts).then(parseJson);
exports.destroyJson = destroyJson;
/**
 * Performs a GET request to the API v2 and returns a promise for the results.
 *
 * @param path - The path of the URL to make the GET request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const get = (path, opts = {}) => {
    return retryNetworkFailures(() => rawRequest('GET', path, opts).then(throwErrorIffNecessary), 3);
};
exports.get = get;
/**
 * Calls `get` and then parses the JSON for you.
 *
 * @param path - The path of the URL to make the GET request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const getJson = (path, opts = {}) => get(path, opts).then(parseJson);
exports.getJson = getJson;
/**
 * Performs a PATCH request and returns a promise for the results.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const patch = (path, opts = {}) => rawRequest('PATCH', path, opts);
exports.patch = patch;
/**
 * Calls `patch` and then parses the JSON for you.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const patchJson = (path, opts = {}) => patch(path, opts).then(parseJson);
exports.patchJson = patchJson;
/**
 * Performs a POST request and returns a promise for the results.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const post = (path, opts = {}) => rawRequest('POST', path, opts);
exports.post = post;
/**
 * Calls `post` and then parses the JSON for you.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const postJson = (path, opts = {}) => post(path, opts).then(parseJson);
exports.postJson = postJson;
/**
 * Performs a PUT request and returns a promise for the results.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const put = (path, opts = {}) => rawRequest('PUT', path, opts);
exports.put = put;
/**
 * Calls `patch` and then parses the JSON for you.
 *
 * @param path - The path of the URL to make the PATCH request to.
 * @param opts - The options for the request.
 *
 * opts:
 *
 * body     - A string, the same as passing `body` to fetch() (optional).
 * params   - A hash of parameters to add to the URL.
 * headers  - Header values (optional).  The header items necessary to
 *            successfully make calls against the bs.com API are included
 *            by default, but can be overridden.
 */
const putJson = (path, opts = {}) => put(path, opts).then(parseJson);
exports.putJson = putJson;
//////////////////////////////////////////////////////////////////////////////
// Delayed Results                                                          //
//////////////////////////////////////////////////////////////////////////////
const delayedResult = (id, delay = 5000, timeout = 90000) => {
    const url = `delayed_results/${id}`;
    const exp = new Date(new Date().getTime() + timeout);
    return handleDr(url, delay, exp);
};
exports.delayedResult = delayedResult;
const handleDr = (url, delay, exp) => {
    if (new Date() > exp)
        throw new Error('timed out');
    return getJson(url).then((rs) => {
        if (!(rs === null || rs === void 0 ? void 0 : rs.stoppedEpoch)) {
            return new Promise((resolve) => setTimeout(() => resolve(handleDr(url, delay, exp)), delay));
        }
        if (rs.error)
            throw new Error(rs.error);
        return rs.result;
    });
};
//////////////////////////////////////////////////////////////////////////////
// Utilities                                                                //
//////////////////////////////////////////////////////////////////////////////
const isEmpty = (obj) => {
    if (obj === null || obj === undefined)
        return true;
    if (typeof obj === 'string')
        return obj.length === 0;
    if (typeof obj === 'object') {
        if (Array.isArray(obj))
            return obj.length === 0;
        return Object.keys(obj).length === 0;
    }
    return false;
};
exports.isEmpty = isEmpty;
const parseJson = (rs) => {
    // 204 == empty response
    if (rs.status === 204)
        return Promise.resolve({});
    return rs.json();
};
const retryNetworkFailures = (promiseMethod, ct) => {
    return new Promise((resolve, reject) => {
        retryNetworkFailuresInner(promiseMethod, ct, resolve, reject);
    });
};
const retryNetworkFailuresInner = (promiseMethod, ct, resolve, reject) => {
    promiseMethod()
        .then(resolve)
        .catch((err) => {
        var _a;
        if ((err === null || err === void 0 ? void 0 : err.message) &&
            ((_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.includes('Network request failed')) &&
            ct > 1) {
            retryNetworkFailuresInner(promiseMethod, ct - 1, resolve, reject);
        }
        else {
            reject(err);
        }
    });
};
const throwErrorIffNecessary = (rs) => {
    var _a;
    if (rs.ok)
        return rs;
    if ((_a = rs.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('json')) {
        return rs.json().then((msg) => {
            const lines = [];
            if (!isEmpty(msg.error))
                lines.push(msg.error);
            if (!isEmpty(msg.errors)) {
                if (Array.isArray(msg.errors)) {
                    msg.errors.forEach((err) => lines.push(`- ${err}`));
                }
                else {
                    Object.keys(msg.errors).forEach((k) => {
                        return lines.push(`- ${k.replace(/_/g, ' ')} ${msg.errors[k]}`);
                    });
                }
            }
            if (lines.length < 1)
                lines.push('Unknown Error');
            // future task todo: POST to packs/:id/cards/:id?question="foo"
            // will return an error object like errors: { answer: "can't be blank" }
            throw new ApiError(lines.join('\n'), rs, msg.errors);
        });
    }
    if (rs.status === 404)
        throw new ApiError('404 Not Found', rs, []);
    return rs.text().then((msg) => {
        throw new ApiError(msg, rs, []);
    });
};
const apiUrl = (host, path, opts) => {
    if (!path.startsWith('/'))
        path = `/api/v2/${path}`;
    return urlFor(host, path, opts.params);
};
exports.apiUrl = apiUrl;
const urlFor = (host, path, params = null) => {
    if (!path.startsWith('/'))
        path = `/${path}`;
    if (params)
        path = `${path}?${query_string_1.default.stringify(params)}`;
    return `${host}${path}`;
};
exports.urlFor = urlFor;
const rawRequest = (method, path, opts) => {
    if (!opts)
        opts = {};
    if (!CONFIG_FUNC)
        return Promise.reject(new Error('No config function set'));
    const { credentials, hdrs, host } = CONFIG_FUNC();
    const url = apiUrl(host, path, opts);
    const headers = buildHeaders(hdrs, opts['headers']);
    const init = { credentials, headers, method };
    if (opts['body'])
        init['body'] = opts['body'];
    return fetch(url, init).then(throwErrorIffNecessary);
};
const buildHeaders = (config, opts) => {
    let headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Brainscape-TZO': new Date().getTimezoneOffset().toString(),
    };
    if (config)
        headers = Object.assign(headers, config);
    if (opts)
        headers = Object.assign(headers, opts);
    return headers;
};
class ApiError {
    constructor(message, rs, errors) {
        this.message = message;
        this.errors = errors;
        if (rs) {
            const token = rs.headers.get('X-BS-AFT');
            if (token)
                this.token = token;
        }
    }
}
